import { render } from "./OverviewPartial.vue?vue&type=template&id=51fa5052&scoped=true"
import script from "./OverviewPartial.vue?vue&type=script&lang=js"
export * from "./OverviewPartial.vue?vue&type=script&lang=js"

import "./OverviewPartial.vue?vue&type=style&index=0&id=51fa5052&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51fa5052"]])

export default __exports__